import React from 'react';
import { Center, CenterProps } from '@chakra-ui/react';

export type QCenterProps = CenterProps;

export const QCenter: React.FC<QCenterProps> = (props) => {
  return <Center {...props} />;
};
